import { GlobalService } from './../global.service';
import { HttpService } from 'src/app/http.service';
import { Component, OnInit } from '@angular/core';
import { ProgressSpinnerMode, ThemePalette } from '@angular/material';

@Component({
  selector: 'app-online-payment-log-excel',
  templateUrl: './online-payment-log-excel.component.html',
  styleUrls: ['./online-payment-log-excel.component.scss']
})
export class OnlinePaymentLogExcelComponent implements OnInit {

  title: any;
  from_date: any;
  to_date: any;
  document_file:any = null;
  is_document_file_avaliable = true;
  input_list = ['Rid', 'Status']
  customer_type_list = [{'name': 'Agent', 'id':[1,2]}, {'name': 'Customer', 'id':[3,4]}]
  selected_customer_type: any = null;
  selected_rid: any = null;
  selected_input: any;
  selected_status: any = null;
  status_list = ['Success', 'Failed', 'Pending', 'Initiated']
  color: ThemePalette = 'primary';
  mode: ProgressSpinnerMode = 'indeterminate';

  constructor(private http:HttpService, private global:GlobalService) {
    this.title = this.global._active_display_name;
  }

  getClicked() {
    this.is_document_file_avaliable = false;
    let data_dict = {
      'from_date': this.from_date,
      'to_date': this.to_date,
      'rid': this.selected_rid,
      'status': this.selected_status,
      'customer_type': this.selected_customer_type,
    }
    console.log(data_dict);
    this.http.serveExcelOnlinePaymentLog(data_dict).subscribe((data) => {
      this.document_file = data;
      if(data['show_alert'] == true){
        this.document_file = null;
        alert(data['alert'])
      }
      console.log(this.document_file)
      this.is_document_file_avaliable = true;
    })

  }

  downloadClicked() {
    const linkSource = 'data:application/xlsx;base64,' + this.document_file['excel'];
    const downloadLink = document.createElement("a");
    const fileName = this.document_file['file_name'];
    downloadLink.href = linkSource;
    downloadLink.download = fileName;
    downloadLink.click();
  }

  changeEvent() {
    this.selected_rid = null;
    this.selected_status = null;
    this.document_file = null;
  }


  ngOnInit() {
  }

}
